import { AppIntegrationsRepository, AppInstancesRepository, DevicesRepository } from 'common/repositories/index';
import { AppInstancesProcessor } from 'common/repositoryProcessors/index';
import Util from 'common/services/util/-RFC.util';
/**
 * Integrations Inactive Processor - inactive apps based on the difference between app-integrations
 * and active instances which are grouped by userId and device
 */

const _processedAppIntegrations = [];

const observableProcessedAppIntegrations = new Rx.BehaviorSubject(_processedAppIntegrations);
const _subjectAppIntegrationsRepository = AppIntegrationsRepository.getObservable();

const AppIntegrationsInactiveProcessor = {

    /**
     * Calculates the inactive integrations for each userId and device
     */
    calculateInactiveAppIntegrations() {

        const integrations = _subjectAppIntegrationsRepository.value;

        if (integrations.length === 0) {

            return;

        }

        const processedInstances = AppInstancesProcessor.getAll();
        const devices = DevicesRepository.getAll();

        devices.forEach((device) => {

            /**
                 * for each device look for the integrations which are not installed or pending
                 * on that device
                 */
            const userId = device.relationships.user.data.id;
            _processedAppIntegrations[userId] = _processedAppIntegrations[userId] || {};
            _processedAppIntegrations[userId][device.id] = [];

            integrations.forEach((integration) => {

                /**
                     * for each integration look for at least one instance installed or pending;
                     * if it's found, the integration should not be added in the
                     * inactive integrations array
                     */
                let foundInstance = false;

                if (processedInstances.length > 0 && processedInstances[userId]) {

                    (processedInstances[userId][device.id] || []).forEach((instance) => {

                        /**
                             * for each instance, based on prototype check if:
                             * is an instance of the current integration
                             * is installed/pending on the current device
                             * if it is, don't push the integration in the
                             * inactive integrations array;
                             * instances which don't have a device are ignored
                             */

                        if (Util.deepFind(
                            instance,
                            'customAppInfo.prototype',
                        ) === integration.attributes.prototype &&
                            String(Util.deepFind(
                                instance,
                                'relationships.device.data.id',
                            )) === String(device.id)) {

                            foundInstance = true;

                        }

                    });

                }

                if (!foundInstance) {

                    const compatibleOsTypes = Util.deepFind(integration, 'attributes.custom.manifest.os') || [];
                    const isCompatibleWithDevice = compatibleOsTypes
                        .indexOf(device.attributes.os) > -1;

                    if (isCompatibleWithDevice) {

                        _processedAppIntegrations[userId][device.id].push(integration);

                    }

                }

            });

        });

        observableProcessedAppIntegrations.onNext(_processedAppIntegrations);

    },

    getObservable() {

        return observableProcessedAppIntegrations;

    },

};

AppInstancesRepository.getObservable().subscribe(
    () => AppIntegrationsInactiveProcessor.calculateInactiveAppIntegrations(),
    () => {},
    () => {},
);
DevicesRepository.getObservable().subscribe(
    () => AppIntegrationsInactiveProcessor.calculateInactiveAppIntegrations(),
    () => {},
    () => {},
);
AppIntegrationsRepository.getObservable().subscribe(
    () => AppIntegrationsInactiveProcessor.calculateInactiveAppIntegrations(),
    () => {},
    () => {},
);

export default AppIntegrationsInactiveProcessor;



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/-RFC.appIntegrationsInactiveProcessor.js